import io, {Socket} from 'socket.io-client'

export function createSocketIo(url: string) {
    return io(url, {
        reconnection: false,
        forceNew: true,
        timeout: 3000,
        transports: ['websocket'],
    })
}

const socketData: {
    [url: string]: Socket
} = {}

export const disconnectAllSocket = () => {
    Object.keys(socketData).forEach((url) => {
        socketData[url]?.disconnect()
        delete socketData[url]
    })
}

export const connectSocket = (url: string) => {
    socketData[url]?.connect()
}

export const disconnectSocket = (url: Maybe<string>) => {
    const key = url ?? ''
    socketData[key]?.disconnect()
    delete socketData[key]
}

export const registerSocket = (url: Maybe<string>) => {
    // url 이 넘어오지 않는다면 polling 으로 전환
    if (url) {
        disconnectSocket(url)
        const socketIo = createSocketIo(url)
        socketData[url] = socketIo
        return socketIo
    }
    return null
}
